<div class="work-item-lane-list">
  <div class="row" *ngIf="isWorkItemListEmpty">
    <div class="bc-layout-wrapper">
      <div class="bc-empty-screen text-center" [attr.data-automation-id]="'bc-empty-lane-list'">
        <svg-icon icon="no-items-happy"></svg-icon>
        <h2 class="bc-empty-title">{{ 'bcCommon.noWorkitemTitle' | translate }}</h2>
        <p class="bc-empty-desc">{{ 'bcCommon.noWorkitemDescription' | translate }}</p>
        <div class="bc-keyboard-shortcuts-info">
          <span>{{ 'bcCommon.noWorkItemHintText' | translate }}</span>
          <a tabindex="0" (keyup.enter)="openSettingsMenu()" class="bc-settings-menu">
            <span [attr.data-automation-id]="'keyboard-shortcuts-link'" (click)="openSettingsMenu()">
              {{ 'bcCommon.noWorkItemHintLink' | translate }}
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="bc-layout-wrapper work-item-lane-container" *ngIf="!isWorkItemListEmpty">
    <ng-container *ngFor="let workItem of workItemList">
      <app-work-item-lane
        *ngIf="getIsWorkItemInDom(workItem)"
        [hidden]="!getIsWorkItemShown(workItem)"
        [workItem]="workItem"
        [attr.data-workitem-id]="workItem.id"
        (activateClick)="selectWorkItem(workItem)"
        [ngClass]="{
        'focused': isFocused(workItem.id),
        'previous': isPreviousWorkItemFromCurrentlySelectedOne(workItem.id),
        'next': isNextWorkItemFromCurrentlySelectedOne(workItem.id),
        'expanded': isExpandedMode() || !workItem.isCollapsible,
        'collapsed': !isExpandedMode() && workItem.isCollapsible }"></app-work-item-lane>
    </ng-container>
  </div>
</div>
